import { useEffect } from 'react';

import { useAppSelector } from 'hooks';
import { selectConversationId } from 'reducers/workflows';
import { submitInteractiveEmailDeflectionFeedback } from 'actions/workflows/workflows';
import { selectRawParams } from 'reducers/config';

export const EndInteractiveEmailChatStep = () => {
  const conversationId = useAppSelector(selectConversationId);
  const token =
    useAppSelector(selectRawParams)?.['data-interactive-email-token'];

  useEffect(() => {
    submitInteractiveEmailDeflectionFeedback({
      conversationId,
      isDeflected: false,
      token,
    });
  }, [conversationId, token]);

  return null;
};
